import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-8" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "my-8"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_monthly_pattern_container = _resolveComponent("monthly-pattern-container")!
  const _component_spot_nursery_pattern_container = _resolveComponent("spot-nursery-pattern-container")!
  const _component_spot_kindergarten_pattern_container = _resolveComponent("spot-kindergarten-pattern-container")!
  const _component_spot_flexible_pattern_container = _resolveComponent("spot-flexible-pattern-container")!
  const _component_spot_combination_pattern_container = _resolveComponent("spot-combination-pattern-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { value: "Extended Pattern Settings" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h5", null, "Monthly & Spot", -1)),
      _createVNode(_component_v_select, {
        modelValue: _ctx.billingPeriod,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.billingPeriod) = $event)),
        items: _ctx.billingPeriodItems,
        "item-title": "text",
        "item-vlaue": "value",
        variant: "outlined",
        "hide-details": "",
        density: "compact"
      }, null, 8, ["modelValue", "items"])
    ]),
    _createElementVNode("div", null, [
      (_ctx.billingPeriod == 'monthly')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_monthly_pattern_container)
          ]))
        : _createCommentVNode("", true),
      (_ctx.billingPeriod == 'spot')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("h5", null, "Extended Time Frame", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.category,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category) = $event)),
              items: _ctx.categoryItems,
              "item-title": "text",
              "item-value": "value",
              variant: "outlined",
              "hide-details": "",
              density: "compact"
            }, null, 8, ["modelValue", "items"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.billingPeriod == 'spot')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.category == 'spot-nursery')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_spot_nursery_pattern_container)
              ]))
            : (_ctx.category == 'spot-kindergarten')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_spot_kindergarten_pattern_container)
                ]))
              : (_ctx.category == 'spot-flexible')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_spot_flexible_pattern_container)
                  ]))
                : (_ctx.category == 'spot-combination')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_spot_combination_pattern_container)
                    ]))
                  : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}